var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.0009L10.6667 24H21.3333C22.8 24 24 22.6502 24 21.0005C24 19.3507 22.8 18.0009 21.3333 18.0009H16ZM12.08 4.78794L0.386667 17.9409C0.146667 18.2109 0 18.6008 0 18.9908V22.5002C0 23.3251 0.6 24 1.33333 24H4.45333C4.81333 24 5.14667 23.835 5.4 23.5651L17.0933 10.4121L12.08 4.78794ZM20.9467 6.06274C21.0703 5.92399 21.1683 5.75918 21.2352 5.57775C21.3022 5.39632 21.3366 5.20182 21.3366 5.0054C21.3366 4.80898 21.3022 4.61449 21.2352 4.43305C21.1683 4.25162 21.0703 4.08681 20.9467 3.94806L17.8267 0.438599C17.7033 0.299565 17.5568 0.18926 17.3955 0.114C17.2342 0.038739 17.0613 0 16.8867 0C16.712 0 16.5391 0.038739 16.3778 0.114C16.2165 0.18926 16.07 0.299565 15.9467 0.438599L13.5067 3.18318L18.5067 8.80732L20.9467 6.06274Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentEditIcon);
export default __webpack_public_path__ + "static/media/content-edit-icon.46e9390784ebf50020c58b77465ddc2e.svg";
export { ForwardRef as ReactComponent };